export default class LinkListHtml {
    constructor(items) {
        this._items = items;
    }

    _getItemHtml() {
        let itemsHtml = '';

        this._items.forEach((item) => {
            itemsHtml += `
                <li class="rfct-link-list__link-item">
                    <a href="${item.link}" class="rfct-link-list__link">
                        <span class="rfct-link-list__link-label">${item.title}</span>
                    </a>
                </li>
            `;
        });

        return itemsHtml;
    }


    toString() {
        return `
            <div class="rfct-link-list">
                <ul class="rfct-link-list__list">
                    ${this._getItemHtml()}
                </ul>
            </div>
        `;
    }
}
